import keyBy from 'lodash/keyBy';
import { select, call } from 'redux-saga/effects';
import * as utilityPreference from '../../services/preference/utilty_preference';
import * as helperInventory from '../../services/inventory/helper_inventory';
import * as apiTaxGroup from '../../services/tax/apiTaxGroup';
import * as apiTaxCode from '../../services/tax/apiTaxCode';
import * as apiPurchaseCommon from '../../services/purchase/common/api_purchase';
import * as sagasCommon from '../sagasCommon';

export function* initializeItemLine(feathersApp, itemLocation) {
  const { tenant, intl } = yield select();
  const taxGroupId = itemLocation.tax_group_id;
  const taxRate = taxGroupId
    ? yield call(apiTaxCode.getTotalTaxRate, feathersApp, taxGroupId)
    : 0;
  const averageCost = itemLocation.average_cost || 0;
  const params = yield call(
    utilityPreference.buildPreferenceQueryFromItemLocation,
    itemLocation,
    ['include_backorder'],
    tenant,
  );
  const preference = yield call(
    utilityPreference.getPreferenceValues,
    feathersApp,
    { ...params, intl },
  );
  const available = helperInventory.calculateQuantityAvailable(
    itemLocation,
    preference,
  );

  let taxGroup = {};
  if (taxGroupId) {
    taxGroup = yield call(apiTaxGroup.fetchTaxGroupById, feathersApp, {
      id: taxGroupId,
    });
  }

  return {
    taxGroup,
    available,
    averageCost,
    taxRate,
  };
}

export function* updateAvailableOnHand(feathersApp, itemLines, availableField) {
  try {
    const itemLocationsQuery = itemLines.map((itemLine) => {
      const { item_id, location_id } = itemLine;
      return {
        item_id: item_id.split(':')[0],
        location_id,
      };
    });

    const itemLocations = yield call(
      apiPurchaseCommon.getItemLocations,
      feathersApp,
      itemLocationsQuery,
    );
    const indexedItemLocations = keyBy(
      itemLocations,
      ({ item_id, location_id }) => `${item_id}:${location_id}`,
    );

    return itemLines.map((itemLine) => {
      const itemLocationId = `${itemLine.item_id.split(':')[0]}:${itemLine.location_id}`;
      const itemLocation = indexedItemLocations[itemLocationId];
      if (itemLocation) {
        const onHand = Number(itemLocation.on_hand) || 0;
        const inTransit = Number(itemLocation.in_transit) || 0;
        const available = onHand - inTransit;
        itemLine[availableField] = available;
        return itemLine;
      } else {
        throw new Error('Item location not found');
      }
    });
  } catch (e) {
    console.error(e.stack);
    yield sagasCommon.showErrorSaveRecord(e);
  }
}
